import { Component, OnInit } from "@angular/core";

@Component({
    template: ""
})
export abstract class LoaderBaseComponent implements OnInit {
    public mostrarLoader = true;

    protected abstract cargarAsync(): Promise<void>;

    public ngOnInit() {
        void this.hacerCargaAsync();
    }

    private async hacerCargaAsync() {
        this.mostrarLoader = true;
        await this.cargarAsync();
        this.mostrarLoader = false;
    }
}
